import React, { Component, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//components
import { Curve, NewBackButton } from "../../../components/svgs";
import { CurveHolder } from "../../../components/common/basic";
// import OfferCard from "../../../components/loyalty/offerCard";

// theme
import { useTheme, useLoyalty } from "../../../hooks";

// import KFCVoucher from "../../../../../public/assets/images/dev/kfc.jpg";
import OfferCards from "../../../components/loyalty/offerCards";
import { OfferAlertModal } from "../../../components/loyalty";
import { Desktop } from "../../../containers/common";

const ViewAllEvents = () => {
  const { themeContext, theme } = useTheme();
  const {
    loyaltyOffersData,
    promoOffersData,
    eventOffersData,
    setSelectedLoyaltyData,
    offerModal,
    setOfferModal,
  } = useLoyalty();
  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "LoyaltyDescription",
        firebase_screen_class: "LoyaltyDescription",
      })
    );
  }, []);

  return (
    <>
      <Desktop>
        <MainHolder>
          <Children>
            {offerModal !== null && (
              <OfferAlertModal
                background={background}
                title={offerModal?.title}
                description={offerModal?.description}
                hideModal={() => {
                  setOfferModal(null);
                }}
              />
            )}
            <BackButtonContainer
              onClick={() => {
                history.goBack();
              }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <DescriptionBody color={mashupBackground}>
              <CurveHolder>
                <Curve fill={mashupBackground} />
              </CurveHolder>
              <ContentHolder>
                {loyaltyOffersData && promoOffersData && (
                  <OfferCards
                    offers={eventOffersData}
                    setData={setSelectedLoyaltyData}
                    setModal={setOfferModal}
                    history={history}
                  />
                )}
              </ContentHolder>
            </DescriptionBody>
          </Children>
        </MainHolder>
      </Desktop>
    </>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const ContentHolder = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: "5px";
  margin-top: 40px;
`;

export default ViewAllEvents;
